export function normalizeReturnTo(
  value: string | null | undefined,
  fallback: string
): string;
export function normalizeReturnTo(
  value: string | null | undefined,
  fallback: null
): string | null;
export function normalizeReturnTo(
  value: string | null | undefined,
  fallback: string | null
) {
  if (typeof value !== "string") return fallback;
  const trimmed = value.trim();
  if (!trimmed) return fallback;
  if (!trimmed.startsWith("/")) return fallback;
  if (trimmed.startsWith("//")) return fallback;
  return trimmed;
}

export function normalizeLinkAccountId(value: string | null | undefined) {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}
